import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'useInventories';

/**
 * Errors related to the Treats Rewards page
 */
export const Errors = createErrors<Page, Component>('useInventories')({
    useInventories: {
        fetchInventoriesBySkuStorePairs: {
            severity: 'MEDIUM',
            message: 'Failed to fetch inventories',
        },
    },
});
